import { render } from "./AppNews.vue?vue&type=template&id=2f11b5c4&scoped=true"
import script from "./AppNews.vue?vue&type=script&lang=js"
export * from "./AppNews.vue?vue&type=script&lang=js"

import "./AppNews.vue?vue&type=style&index=0&id=2f11b5c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f11b5c4"]])

export default __exports__